<div class="box">
  <div class="broom">
  </div>

  @if (statesService.wipingPee) {
    <div class="pee" [style.background-image]="statesService.backgroundImageSrc"></div>
  }
  @if (statesService.wipingPoo) {
    <div class="poo" [style.background-image]="statesService.backgroundImageSrc"></div>
  }
</div>
